
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/openai-api-ui-for-rapid-prototyping",
      function () {
        return require("private-next-pages/openai-api-ui-for-rapid-prototyping.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/openai-api-ui-for-rapid-prototyping"])
      });
    }
  